export const IMAGE_NOT_FOUND_URL = "//content.speedwaymotors.com/OtherImages/missingimage2.jpg"